(function () {
  "use strict";

  angular.module("PrintixProviderMetric", [])

      .constant("RequiredMetricModelProperties", [
          "_links"
      ])

      .service("MetricListService", ["$rootScope", "$filter", "Utils", "TenantListService", "$http", "$q",
          "USER_RIGHTS",
          function ($rootScope, $filter, Utils, TenantListService, $http, $q, USER_RIGHTS) {
              //START VARIABLES**************************************************************************************/
              var MetricListModelPrivate = {}, metricListServiceAsObject = this;
              this.metricModel = {};
              //END VARIABLES****************************************************************************************/


              //START MetricListModelPrivate*************************************************************************/
              MetricListModelPrivate.readMetricRequest = function (response) {
                  if (response.data) {
                      metricListServiceAsObject.metricModel = angular.copy(response.data);
                  } else {
                      throw "MetricListModelPrivate.readMetricRequest: metric data is missing";
                  }
              };

              this.getMetric = function (interval) {
                  if (interval) {
                      if ($rootScope.currentUser) {
                          if (TenantListService.currentTenant &&
                              TenantListService.currentTenant.info._links["px:dataanalysis"].href) {
                              metricListServiceAsObject.metricModel = {};
                              var url = TenantListService.currentTenant.info._links["px:dataanalysis"].href + "?days=" + interval;
                              var deferred = $q.defer();
                              $http.get(url).then(function (response) {
                                  MetricListModelPrivate.readMetricRequest(response);
                                  deferred.resolve(response);
                              }).catch(function(error) {
                                  deferred.reject(error);
                              });
                              return deferred.promise;
                          } else {
                              throw "MetricListService.getMetric: TenantListService.currentTenant or TenantListService.currentTenant.info._links[px:metricASDASD].href are missing";
                          }
                      }
                  } else {
                      throw "MetricListModelPrivate.getMetric: interval is missing";
                  }
              };
              //END MetricListModelPrivate***************************************************************************/


              //START EVENT LISTENERS*************************************************************************************/
              //END EVENT LISTENERS***************************************************************************************/
          }]);
})();